import classNames from "classnames";
import { FC, PropsWithChildren } from "react";
import styles from "./Sections.module.css";

type SectionsProps = PropsWithChildren<{
  className?: string;
  columns?: 2 | 3;
  expandLastOnTablet?: boolean;
}>;

const Sections: FC<SectionsProps> = ({
  children,
  className,
  columns = 3,
  expandLastOnTablet = false,
}: SectionsProps) => (
  <div
    className={classNames(
      styles.sections,
      columns === 2 ? styles.columns2 : styles.columns3,
      expandLastOnTablet ? styles.expandLastOnTablet : undefined,
      className,
    )}
  >
    {children}
  </div>
);

export default Sections;
